var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5254 15.8984H33.25V15.8327H19V22.166H27.9482C26.6427 25.8528 23.1349 28.4994 19 28.4994C13.7536 28.4994 9.49999 24.2457 9.49999 18.9994C9.49999 13.753 13.7536 9.49935 19 9.49935C21.4217 9.49935 23.6249 10.4129 25.3025 11.9052L29.7809 7.42677C26.9531 4.79131 23.1705 3.16602 19 3.16602C10.256 3.16602 3.16666 10.2554 3.16666 18.9994C3.16666 27.7433 10.256 34.8327 19 34.8327C27.7439 34.8327 34.8333 27.7433 34.8333 18.9994C34.8333 17.9377 34.7241 16.9014 34.5254 15.8984Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99225 11.6297L10.1943 15.4448C11.6019 11.9598 15.0108 9.49935 19 9.49935C21.4217 9.49935 23.6249 10.4129 25.3025 11.9052L29.7809 7.42677C26.9531 4.79131 23.1705 3.16602 19 3.16602C12.9184 3.16602 7.64433 6.59947 4.99225 11.6297Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 34.8329C23.0898 34.8329 26.8058 33.2678 29.6155 30.7226L24.7151 26.5758C23.072 27.8254 21.0643 28.5012 19 28.4996C14.8818 28.4996 11.385 25.8736 10.0676 22.209L4.90439 26.1871C7.52481 31.3147 12.8464 34.8329 19 34.8329Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5254 15.8997H33.25V15.834H19V22.1673H27.9482C27.3237 23.922 26.1989 25.4552 24.7127 26.5777L24.715 26.5761L29.6155 30.7229C29.2687 31.0379 34.8333 26.9173 34.8333 19.0007C34.8333 17.939 34.7241 16.9027 34.5254 15.8997Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.27bf14b09839d1c5a6a223018ab201d9.svg";
export { ForwardRef as ReactComponent };